import { Directive, ElementRef, HostListener, Input, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[convertAlphanumeric]',
  standalone: true,
})
export class ConvertAlphanumericDirective {
  @Input() sfMaxLength: number | string | null | undefined;
  constructor(private el: ElementRef, @Self() private control: NgControl) {}

  @HostListener('blur')
  onBlur(): void {
    const raw: string = this.el.nativeElement.value ?? '';
    let converted = raw.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) =>
      String.fromCharCode(s.charCodeAt(0) - 0xfee0)
    );
    // These legacy numeric fields explicitly normalize their input on blur.
    const min = this.el.nativeElement.minLength;
    const max = Number(this.sfMaxLength);
    if (min > 0 && converted.length < min) converted = '';
    else if (max > 0) converted = converted.slice(0, max);
    const pattern = this.el.nativeElement.pattern;
    if (pattern && !new RegExp('^(?:' + pattern + ')$').test(converted)) converted = '';
    if (converted !== raw) {
      this.control.control?.setValue(converted);
    }
  }
}
